import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import * as css from './TransactionAddressBlock.css';
import {buildNavigationUrl, openUrl} from '../transactionCardUtils';

interface TransactionAddressBlockProps {
    location: string;
}

function TransactionAddressBlock({location}: TransactionAddressBlockProps) {
    const {t} = useTranslation('eTicket');
    return (
        <css.addressRow data-cy="transaction-address">
            <css.block>
                <css.blockHeading>{t('eventAddress')}</css.blockHeading>
                <css.blockLine>{location}</css.blockLine>
            </css.block>
            <Button
                variant="neutral"
                size="chip"
                onClick={() => openUrl(buildNavigationUrl(location))}
                data-cy="transaction-navigate">
                {t('navigate')}
            </Button>
        </css.addressRow>
    );
}

export default TransactionAddressBlock;
